<template>
  <b-form-group
    label="Select the unit for the bubble total"
    label-cols="3"
  >
    <b-radio-group
      v-model="_isMultipleUnits"
      :options="unitMultipleOptions"
      class="btn-block py-1"
      buttons
      button-variant="outline-primary"
    />
    <b-form-text>{{ unitLabelHelpText }}</b-form-text>
    <b-input-group v-if="!isMultipleUnits">
      <b-input
        :value="totalUnitLabel"
        :disabled="totalUnitType === MONETARY"
        @input="$emit('update:totalUnitLabel', $event)"
      />
      <b-input-group-append is-text>
        <b-checkbox v-model="isUnitMonetary">
          Monetary
        </b-checkbox>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'
import { FieldTypes } from '@/types'
import { MONETARY_UNIT } from '@/constants'

const props = {
  totalUnitType: {
    type: String,
    default: '',
  },
  totalUnitLabel: {
    type: String,
    default: '',
  },
  isMultipleUnits: Boolean,
}

@Component
export default class DefineUnitForTotal extends Vue.extend({ props }) {
  unitMultipleOptions = [
    { value: false, text: 'Single Unit' },
    { value: true, text: 'Multiple Units' },
  ]

  MONETARY = FieldTypes.MONETARY

  get unitLabelHelpText () {
    if (this.isMultipleUnits) return 'Specify multiple units in the builder'
    else return 'Specify a single common unit for the total'
  }

  get isUnitMonetary () {
    return this.totalUnitType === FieldTypes.MONETARY
  }

  set isUnitMonetary (isMonetary: boolean) {
    if (isMonetary) {
      this.$emit('update:totalUnitType', FieldTypes.MONETARY)
      this.$emit('update:totalUnitLabel', MONETARY_UNIT)
    } else {
      this.$emit('update:totalUnitType', FieldTypes.NUMERIC)
      this.$emit('update:totalUnitLabel', '')
    }
  }

  get _isMultipleUnits () {
    return this.isMultipleUnits
  }

  set _isMultipleUnits (isMultipleUnits) {
    this.$emit('update:isMultipleUnits', isMultipleUnits)
    if (isMultipleUnits) {
      this.$emit('update:totalUnitType', FieldTypes.NUMERIC)
      this.$emit('update:totalUnitLabel', '')
    }
  }
}

</script>
